import {Component, OnInit, ViewChild} from '@angular/core';
import {ParentService} from "../../services/mygreencountry/parent.service";
import {PreloaderService} from "../../services/preloader/preloader.service";
import {FaqResponse} from "../../types/apiResponse.interface";
import {IonAccordionGroup} from "@ionic/angular";
import {TranslocoService} from "@jsverse/transloco";
import {Title} from "@angular/platform-browser";
import {Observable} from "rxjs";

@Component({
    selector: 'app-faq',
    templateUrl: './faq.page.html',
    styleUrls: ['./faq.page.scss'],
})
export class FaqPage implements OnInit {
    title$: Observable<string>;

    @ViewChild('accordionGroup', { static: true }) accordionGroup!: IonAccordionGroup;
    public currentAccordion: number | null = null;
    public faqs : FaqResponse[]|undefined= undefined;

    constructor(
        private parentService: ParentService,
        private preloaderService: PreloaderService,
        private translocoService: TranslocoService,
        private titleService: Title
    ) {
        this.title$ = this.translocoService.selectTranslate('route.faq');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });
    }

    ngOnInit() {
    }

    ionViewDidEnter() {
        this.loadFaq();
    }

    refresh(event: any) {
        this.loadFaq(event);
    }

    onAccordionChange(event: CustomEvent): void {
        this.currentAccordion = event.detail.value;
        console.log(this.currentAccordion)
    }

    async loadFaq( event: any = null) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.parentService.getFaq()
            .subscribe({

                next: (response) => {
                    this.faqs = response;

                    console.log( this.faqs)
                },

                error: (error) => {
                    console.log('error', error)
                },

                complete: () => {
                    this.preloaderService.hideLoading();

                    if (event) {
                        event.target.complete();
                    }
                }

            })
    }

}
